<template>
 <section class="section">
        <div class="container">
           <content-placeholders>
                <content-placeholders-heading  />
                <content-placeholders-heading :img="false" />
              </content-placeholders>
        </div>
      </section>
</template>

<script>
import api from '@/api/offer-api'
export default {
  name: 'Redirect',
  async mounted() {
    if (this.$route.params.id) {
      try {
        const result = await api.getOfferByVariantId(this.$route.params.id)
        this.$router.push({name: 'urlaub', params: {contact: result.contact.slug, slug: result.slug}})
      } catch {
            this.$router.push({name: '404'})
      }
    } else {
      this.$router.push({name: '404'})
    }
  },
}
</script>
